export enum TemplateTypes {
  FlowRepublished = "flowRepublished",
  FlowKeepLearning = "flowKeepLearning",
  AddedToFlowV2 = "addedToFlowV2",
  AddedToVideo = "addedToVideo",
  VideoChanged = "videoChanged",
  AddedToAssessment = "addedToAssessment",
  AssessmentChanged = "assessmentChanged",
  EventDetailsChanged = "eventDetailsChangedV2",
  AddedToPdf = "addedToPdf",
  PdfChanged = "pdfChanged",
  AddedToGroup = "addedToGroup",
  WelcomeEmail = "welcomeEmail",
  EventAssigned = "eventAssigned",
  AddedToSurvey = "addedToSurvey",
  AccountCreated = "accountCreated",
  SurveyChanged = "surveyChanged",
  ApproveGroupTemplate = "approveGroupTemplate",
  AddedToEmbeddedVideo = "addedToEmbeddedVideo",
  EmbeddedVideoChanged = "embeddedVideoChanged",
  SCORMChanged = "SCORMChanged",
  AddedToSCORM = "addedToSCORM",
  Empty = "",
}
